import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const ProductSelect = ({ handleChange, options, selectedValue, index }) => {

  const updateProduct = (product) => {
    if (product !== null) {
        handleChange(product);
    }
  }

  return (
    <Fragment>
      <input name={(index !== null) && `invoice[lineitems_attributes][${index}][p_code]`}
             defaultValue={selectedValue && selectedValue.value}
             hidden/>
      <SingleSelect
        handleChange={updateProduct}
        options={options}
        selectedValue={selectedValue}
        showCheckbox={true}
        placeholderText='Select product'
      />
    </Fragment>
  );
};

ProductSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  index: PropTypes.number
};

ProductSelect.defaultProps = {
  options: [{}],
  selectedValue: {},
  index: 0
};

export default ProductSelect;
